import primary from './primary'
import secondary from './secondary'
import background from './background'

// Default color values
export const DEFAULT_COLORS = {
  primary: '#f84c6c',
  secondary: '#0f1231',
  background: '#FFFFFF',
}

// Environment variable keys
export const COLOR_ENV_KEYS = {
  primary: 'REACT_APP_PRIMARY_COLOR',
  secondary: 'REACT_APP_SECONDARY_COLOR',
  background: 'REACT_APP_BACKGROUND_COLOR',
}

// Get color from environment variable or use default
export const getColorFromEnv = (colorKey: keyof typeof COLOR_ENV_KEYS): string => {
  const envKey = COLOR_ENV_KEYS[colorKey]
  return process.env[envKey] || DEFAULT_COLORS[colorKey]
}

export { primary, secondary, background }
